module.exports = __webpack_public_path__ + "static/media/AM.37319125.png";